import React from 'react';

const PARTNERS = [
  "Инвестиционные комитеты",
  "Венчурные фонды (VC)",
  "Государственные структуры",
  "Частные фонды",
  "Family Offices",
  "Private Equity (PE)",
  "Медицинские холдинги"
];

export const CooperationTicker = () => {
  return (
    <div className="w-full bg-[#141416] py-4 border-y border-[#8C6D37]/30 overflow-hidden relative">
      {/* Gradients for smooth fading edges */}
      <div className="absolute inset-y-0 left-0 w-16 md:w-32 bg-gradient-to-r from-[#141416] to-transparent z-10 pointer-events-none" />
      <div className="absolute inset-y-0 right-0 w-16 md:w-32 bg-gradient-to-l from-[#141416] to-transparent z-10 pointer-events-none" />
      
      <div className="flex items-center gap-4">
        <span className="shrink-0 pl-6 md:pl-12 font-mono text-[11px] text-[#8C6D37] uppercase tracking-[0.2em] font-bold z-20 bg-[#141416] py-1 shadow-[8px_0_12px_rgba(20,20,22,1)]">
          ИНВЕСТИЦИОННЫЙ СИНДИКАТ:
        </span>
        
        <div className="flex flex-1 overflow-hidden relative ticker-wrap">
          <div className="flex whitespace-nowrap gap-12 items-center ticker-inner">
            {/* Duplicate array for seamless infinite scroll */}
            {[...PARTNERS, ...PARTNERS, ...PARTNERS, ...PARTNERS].map((partner, idx) => (
              <div key={idx} className="flex items-center gap-12">
                <span className="text-[#94A3B8] font-sans text-[13px] tracking-wide">
                  {partner}
                </span>
                <span className="text-[#8C6D37]/30 text-xs">/</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
